import { useCallback, useSyncExternalStore } from 'react';
import {
  FONT_SCALE_STEPS,
  initFontScaleFromStorage,
  readStoredFontScale,
  stepFontScale,
} from '../utils/fontScale.js';

const DEFAULT_SCALE = FONT_SCALE_STEPS[1]; // 110%

let currentScale = typeof document !== 'undefined' ? readStoredFontScale() : DEFAULT_SCALE;
const listeners = new Set();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return currentScale;
}

function emit(scale) {
  currentScale = scale;
  listeners.forEach((fn) => fn());
}

export function useFontScale() {
  const scale = useSyncExternalStore(subscribe, getSnapshot, () => DEFAULT_SCALE);

  const increase = useCallback(() => {
    emit(stepFontScale(getSnapshot(), 'up'));
  }, []);

  const decrease = useCallback(() => {
    emit(stepFontScale(getSnapshot(), 'down'));
  }, []);

  const min = FONT_SCALE_STEPS[0];
  const max = FONT_SCALE_STEPS[FONT_SCALE_STEPS.length - 1];

  return {
    scale,
    increase,
    decrease,
    canIncrease: scale < max,
    canDecrease: scale > min,
    isDefault: scale === DEFAULT_SCALE,
  };
}

/** Llamar una vez al arranque (antes del render) para evitar parpadeo. */
export function bootstrapFontScale() {
  const value = initFontScaleFromStorage();
  currentScale = value;
  return value;
}
